import React, { Component } from 'react';
import Pod from './Pod';
import VisibilityToggle from './VisibilityToggle'
class Method extends Component {
  constructor(props) {
    super(props);
    this.state = {visible: true};
  }

  setVisibilitity = (visible) => this.setState({visible: visible});

  render() {
    return (
      <div style={{marginBottom: 10+'px'}}>
        <div><VisibilityToggle visible={this.state.visible} onChange={this.setVisibilitity}/> method {this.props.name}({this.props.sig})</div>
        {
          this.state.visible
          && <div style={{paddingLeft: 20+'px'}}>
               <Pod contents={this.props.desc}/>
             </div>
        }
      </div>
    )
  }
}

export default Method;



// WEBPACK FOOTER //
// ./src/Method.js